import { GROUPS_SERVICE } from "@/services/groups.service.js";

const state = {postGroupOutput: false, getGroupsOutput: {}, getGroupByIdOutput: {}, deleteGroupByIdOutput: false, putVariationOutput: false, deleteVariationOutput: false, putGroupOutput: false};

const actions = {
    //Service to create groups
    postGroup({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postGroupRequest');

        GROUPS_SERVICE.postGroup(input)
            .then(
                output => {
                    commit('postGroupSuccess', output);
                },
                error => {
                    commit('postGroupFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get paginated groups
    getGroups({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getGroupsRequest');

        GROUPS_SERVICE.getGroups(queryParams)
            .then(
                output => {
                    commit('getGroupsSuccess', output);
                },
                error => {
                    commit('getGroupsFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get group details
    getGroupById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('getGroupByIdRequest');

        GROUPS_SERVICE.getGroupById(id)
            .then(
                output => {
                    commit('getGroupByIdSuccess', output);
                },
                error => {
                    commit('getGroupByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to delete groups
    deleteGroupById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('deleteGroupByIdRequest');

        GROUPS_SERVICE.deleteGroupById(id)
            .then(
                output => {
                    commit('deleteGroupByIdSuccess', output);
                },
                error => {
                    commit('deleteGroupByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to add variations
    putVariation({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putVariationRequest');

        GROUPS_SERVICE.putVariation(input)
            .then(
                output => {
                    commit('putVariationSuccess', output);
                },
                error => {
                    commit('putVariationFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to delete variation from group
    deleteVariation({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('deleteVariationRequest');

        GROUPS_SERVICE.deleteVariation(id)
            .then(
                output => {
                    commit('deleteVariationSuccess', output);
                },
                error => {
                    commit('deleteVariationFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    // Service to update group
    putGroup({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putGroupRequest');

        GROUPS_SERVICE.putGroup(input)
            .then(
                output => {
                    commit('putGroupSuccess', output);
                },
                error => {
                    commit('putGroupFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //postGroup
    postGroupRequest(state) {
        state.postGroupOutput = null;
    },
    postGroupSuccess(state, output) {
        state.postGroupOutput = true;
    },
    postGroupFailure(state) {
        state.postGroupOutput = false;
    },

    //getGroups
    getGroupsRequest(state) {
    },
    getGroupsSuccess(state, output) {
        state.getGroupsOutput = output;
    },
    getGroupsFailure(state) {
        state.getGroupsOutput = false;
    },

    //getGroupById
    getGroupByIdRequest(state) {
    },
    getGroupByIdSuccess(state, output) {
        state.getGroupByIdOutput = output;
    },
    getGroupByIdFailure(state) {
        state.getGroupByIdOutput = false;
    },

    //deleteGroupById
    deleteGroupByIdRequest(state) {
        state.deleteGroupByIdOutput = null;
    },
    deleteGroupByIdSuccess(state, output) {
        state.deleteGroupByIdOutput = true;
    },
    deleteGroupByIdFailure(state) {
        state.deleteGroupByIdOutput = false;
    },

    //putVariation
    putVariationRequest(state) {
        state.putVariationOutput = null;
    },
    putVariationSuccess(state, output) {
        state.putVariationOutput = true;
    },
    putVariationFailure(state) {
        state.putVariationOutput = false;
    },

    //deleteVariation
    deleteVariationRequest(state) {
        state.deleteVariationOutput = null;
    },
    deleteVariationSuccess(state, output) {
        state.deleteVariationOutput = true;
    },
    deleteVariationFailure(state) {
        state.deleteVariationOutput = false;
    },

    //putGroup
    putGroupRequest(state) {
        state.putGroupOutput = null;
    },
    putGroupSuccess(state, output) {
        state.putGroupOutput = true;
    },
    putGroupFailure(state) {
        state.putGroupOutput = false;
    },
};

export const groups = {
    namespaced: true,
    state,
    actions,
    mutations
};